// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// TWINGATE NETWORK SCHEMA
/////////////////////////////////////////

export const TwingateNetworkSchema = z.object({
  id: z.string(),
  tenantId: z.string(),
  slug: z.string(),
  displayName: z.string(),
  networkId: z.string(),
  networkName: z.string(),
  groupId: z.string(),
  groupName: z.string(),
  serviceAccountId: z.string().nullable(),
  serviceAccountKey: z.string(),
  keyExpiresAt: z.coerce.date().nullable(),
  isDefault: z.boolean(),
  isActive: z.boolean(),
  usesLegacyProxyNaming: z.boolean(),
  proxyDeploymentRevision: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type TwingateNetwork = z.infer<typeof TwingateNetworkSchema>

export default TwingateNetworkSchema;
